import { createApp } from 'vue'
import Demo from './Demo.vue'

createApp(Demo).mount('#app')
